import { Dialog, DialogTitle } from "@mui/material";
import styled from "styled-components";
import { FailIcon, SuccessIcon } from "../assets/icons/icons";
import theme from "../theme";
import { uploadResult } from "../types/types";
import { Button } from "./common/Button";
import { CustomTooltip } from "./common/CustomTooltip";
import { textSubstring } from "../utils/util";

interface ModalProps {
  open: boolean;
  close: () => void;
  data?: uploadResult[];
  onClose: any;
  onPressNo: any;
}

const MultipleDeviceModal: React.FC<ModalProps> = (props) => {
  const { open, close, data, onClose, onPressNo } = props;
  // const [count, setCount] = useRecoilState(deviceCounts);
  // const [toast, setToast] = useRecoilState(toastState);

  // console.log("data", data);
  // console.log(data && data.length == 0);
  return (
    <Dialog
      open={open}
      onClose={close}
      PaperProps={{
        sx: {
          minWidth: "1580px",
          minHeight: "600px",
          pt: "30px",
          pl: "30px",
          pr: "30px",
          borderRadius: "20px",
          pb: "50px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: "15px",
          lineHeight: "18px",
          pl: "0px",
        }}
      >
        업로드 기기 목록 - {data?.length}건
      </DialogTitle>
      <Separator />
      <TableHeader>
        <TableHeaderList>기기 종류</TableHeaderList>
        <TableHeaderList>소유자</TableHeaderList>
        <TableHeaderList>소유자 연락처</TableHeaderList>
        <TableHeaderList>추가 알림 수신자</TableHeaderList>
        <TableHeaderList>추가 알림 수신자 연락처</TableHeaderList>
        <TableHeaderList>주소</TableHeaderList>
        <TableHeaderList>단말기 시리얼 번호</TableHeaderList>
        <TableHeaderList>단말기 전화번호</TableHeaderList>
        {/* <TableHeaderList>담당기관</TableHeaderList> */}
        <TableHeaderList>그룹</TableHeaderList>
      </TableHeader>
      <TableBody>
        {!data ||
          (data.length == 0 && (
            <div
              style={{
                flexGrow: "1",
                textAlign: "center",
                paddingTop: "30px",
              }}
            >
              업로드된 데이터가 없습니다.
            </div>
          ))}
        {data?.map((el) => (
          <TableList isFail={el.success === 0} key={el.devicePhone}>
            {/* 기기 종류 */}
            <MobInfo
              style={{
                textAlign: "center",
                width: "125px",
              }}
            >
              {el.mobility_type}
            </MobInfo>

            {/* 소유자 */}
            <CustomTooltip title={el?.name} active={el?.name?.length > 8}>
              <MobInfo
                style={{
                  width: "125px",
                  textAlign: "center",
                }}
              >
                {textSubstring(el.name, 0, 8)}
              </MobInfo>
            </CustomTooltip>

            {/* 소유자 연락처 */}
            <MobInfo style={{ width: "145px" }}>{el.phone}</MobInfo>

            {/* 추가 알림 수신자 */}
            <CustomTooltip
              title={el?.nokName}
              active={el?.nokName?.length > 8}
            >
              <MobInfo
                style={{
                  width: "70px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {textSubstring(el.nokName, 0, 8)}
              </MobInfo>
            </CustomTooltip>

            {/* 추가 알림 수신자 연락처 */}
            <MobInfo style={{ width: "145px" }}>{el.nokPhone}</MobInfo>

            {/* 주소 */}
            <MobInfo style={{ width: "230px" }}>{el.address}</MobInfo>

            {/* 단말기 시리얼 번호 */}
            <MobInfo style={{ width: "145px" }}>{el.devicePid}</MobInfo>

            {/* 단말기 전화번호 */}
            <MobInfo style={{ width: "145px" }}>{el.devicePhone}</MobInfo>

            {/* 담당기관 */}
            <CustomTooltip
              title={el?.govName}
              active={el?.govName?.length > 8}
            >
              <MobInfo style={{ width: "145px" }}>
                {textSubstring(el.govName, 0, 8)}
              </MobInfo>
            </CustomTooltip>

            <div style={{ position: "absolute", right: "15px" }}>
              {el.success === 1 ? <SuccessIcon /> : <FailIcon />}
            </div>
          </TableList>
        ))}
        <ButtonContainer>
          <Button
            bgColor={theme.statusColor.MAIN}
            hoverColor={theme.statusColor.MAIN_HOVER}
            onClick={() => {
              if (data && data.length > 0) {
                // setCount(data?.filter((el) => el.success === 1).length);
                // setToast((prev) => {
                //   return { ...prev, multipleDeviceSuccess: true };
                // });
                close();
                onPressNo();
                onClose();
              }
            }}
            disabled={!data || data.length == 0}
            style={{ width: "330px", height: "50px" }}
          >
            확인
          </Button>
          <Button
            bgColor={theme.statusColor.CLOSE}
            hoverColor={theme.statusColor.CLOSE_HOVER}
            onClick={close}
            style={{ width: "330px", height: "50px" }}
          >
            취소
          </Button>
        </ButtonContainer>
      </TableBody>
    </Dialog>
  );
};

const TableHeader = styled.div`
  margin-top: 15px;
  margin-bottom: 10px;
`;

const TableHeaderList = styled.span`
  &:nth-child(1) {
    margin-left: 60px;
    margin-right: 100px;
  }
  &:nth-child(2) {
    margin-right: 100px;
  }
  &:nth-child(3) {
    margin-right: 72px;
  }
  &:nth-child(4) {
    margin-right: 73px;
  }
  &:nth-child(5) {
    margin-right: 150px;
  }
  &:nth-child(6) {
    margin-right: 137px;
  }
  &:nth-child(7) {
    margin-right: 65px;
  }
  &:nth-child(8) {
    margin-right: 95px;
  }
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_500};
`;

const Separator = styled.div`
  background-color: ${theme.color.neutral_200};
  width: 100%;
  height: 3px;
`;

const TableBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TableList = styled.div<{ isFail: boolean }>`
  background: ${theme.color.neutral_50};
  border-radius: 10px;
  width: 100%;
  position: relative;
  height: 46px;
  display: flex;
  gap: 40px;
  align-items: center;
  padding-left: 30px;
  padding-right: 43px;
  background: ${({ isFail }) =>
    isFail ? theme.color.red_100 : theme.color.white};
`;

const MobInfo = styled.span`
  display: block;
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_600};
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export default MultipleDeviceModal;
